export const API_ENDPOINTS = {
    FIND_BY_SLUG: "/api/v1/content/find-by-slug",
    APPLY_CONTACT: "/api/contact",

    ROUTE_URL: {
        CONTACT: "contact",
        BUSINESS_CONTACT: "businessContact",
        SALE_CONTACT: "saleContact",
        COMPANY: "company",
        CAREER: "career",
        HEADER: "header",
        FOOTER: "footer",
        PRODUCT: "product",
        JOB_DETAIL: "jobDetail"
    },

    GET_JOB_INDEX: "/api/job/index",
    GET_JOB_DETAIL: "/api/job/detail",
    APPLY_JOB: "/api/job/apply",
    GET_JOB_POSITION: "/api/job/index",
    GET_DEPARTMENT_LIST: "/api/department/index",
    GET_JOB_LEVEL_INDEX: "/api/job-level/index",
    GET_COUNTRY: "/api/v1/country"
}